module.exports = __webpack_public_path__ + "img/9-black-diamond.ba56ec16.png";